// Arabic translations
const ar = {
  // Header translations
  transaction: 'المعاملة',
  prop: 'الدعم',
  explore: 'استكشف',
  profit: 'الربح',
  assets: 'الأصول',
  credit: 'الائتمان',
  balance: 'الرصيد',
  freeMargin: 'الهامش الحر',
  margin: 'الهامش',
  marginLevel: 'مستوى الهامش',
  openRealAccount: 'افتح حساب حقيقي',
  
  // Market Watch
  marketWatch: 'مراقبة السوق',
  favorites: 'المفضلة',
  mostActive: 'الأكثر نشاطاً',
  all: 'الكل',
  searchSymbols: 'البحث عن الرموز...',
  
  // Trading Actions
  buy: 'شراء',
  sell: 'بيع',
  close: 'إغلاق',
  
  // Trading Modal
  market: 'السوق',
  pending: 'معلق',
  currentPrice: 'السعر الحالي',
  volume: 'الحجم',
  lot: 'لوت',
  price: 'السعر',
  stopLoss: 'وقف الخسارة',
  takeProfit: 'جني الأرباح',
  optional: 'اختياري',
  marketOrder: 'أمر السوق',
  pendingOrder: 'أمر معلق',
  executionPrice: 'سعر التنفيذ',
  cancel: 'إلغاء',
  
  // Positions Panel
  openPositions: 'المراكز المفتوحة',
  pendingOrders: 'الأوامر المعلقة',
  closedPositions: 'المراكز المغلقة',
  finance: 'المالية',
  noOpenPositions: 'ليس لديك مراكز مفتوحة. ابدأ التداول لرؤية مراكزك المفتوحة هنا.',
  noPendingOrders: 'لا توجد أوامر معلقة.',
  noClosedPositions: 'لا توجد مراكز مغلقة.',
  noFinancialHistory: 'لا يوجد تاريخ مالي.',
  
  // Common terms
  symbol: 'الرمز',
  type: 'النوع',
  pnl: 'الربح/الخسارة',
  swap: 'المبادلة',
  commission: 'العمولة',
  spread: 'السبريد',
  time: 'الوقت',
  
  // Account info
  equity: 'رأس المال',
  usedMargin: 'الهامش المستخدم',
  accountBalance: 'رصيد الحساب',
  
  // Connection status
  connected: 'متصل',
  connecting: 'جاري الاتصال...',
  disconnected: 'غير متصل',
  
  // Mobile-specific translations
  accountSummary: 'ملخص الحساب',
  selectField: 'اختر الحقل',
  
  // Modal-specific translations
  buyOrder: 'أمر شراء',
  sellOrder: 'أمر بيع',
  
  // Navigation translations
  symbols: 'الرموز',
  chart: 'الرسم البياني',
  positions: 'المراكز',
  
  // Account management
  account: 'الحساب',
  notifications: 'الإشعارات',
  markAllRead: 'وضع علامة مقروء على الكل',
  noNotifications: 'لا توجد إشعارات',
  
  // Market Watch Settings Modal
  marketWatchSettings: 'إعدادات مراقب السوق',
  general: 'عام',
  display: 'العرض',
  generalSettings: 'الإعدادات العامة',
  displaySettings: 'إعدادات العرض',
  autoRefresh: 'التحديث التلقائي',
  autoRefreshDesc: 'تحديث الأسعار تلقائياً',
  soundAlerts: 'تنبيهات صوتية',
  soundAlertsDesc: 'تنبيهات صوتية لتغير الأسعار',
  updateInterval: 'فترة التحديث',
  second: 'ثانية',
  seconds: 'ثواني',
  showSpread: 'إظهار السبريد',
  showSpreadDesc: 'إظهار فرق العرض والطلب',
  showVolume: 'إظهار الحجم',
  showVolumeDesc: 'إظهار حجم التداول',
  decimalPlaces: 'الأرقام العشرية',
  colorTheme: 'موضوع الألوان',
  default: 'افتراضي',
  greenRed: 'أخضر-أحمر',
  blueOrange: 'أزرق-برتقالي',
  save: 'حفظ',

  // Technical Indicators
  indicators: 'المؤشرات',
  technicalIndicators: 'المؤشرات الفنية',
  sma20: 'متوسط متحرك بسيط 20',
  sma50: 'متوسط متحرك بسيط 50',
  ema12: 'متوسط متحرك أسي 12',
  ema26: 'متوسط متحرك أسي 26',
  rsi14: 'مؤشر القوة النسبية 14',
  bollingerBands: 'نطاقات بولينجر',
  movingAverage: 'المتوسط المتحرك',
  exponentialMovingAverage: 'المتوسط المتحرك الأسي',
  relativeStrengthIndex: 'مؤشر القوة النسبية',
  macd: 'مؤشر الماكد',
  stochastic: 'مؤشر ستوكاستيك',
  atr: 'متوسط المدى الحقيقي',
  volume: 'الحجم',
  
  // Chart loading states
  loadingChart: 'جاري تحميل الرسم البياني...',
  initializing: 'جاري التهيئة',
  chartReady: 'الرسم البياني جاهز'
};

export default ar;